import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck, Hammer, Sparkles } from "lucide-react";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1756079664354-34944e001f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwbW9kZXJuJTIwYmF0aHJvb20lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc3Mjk1MDgxfDA&ixlib=rb-4.1.0&q=85";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 c4-rise">
          <span
            data-testid="hero-overline"
            className="uppercase text-xs tracking-[0.3em] text-[#C9A24A] font-semibold"
          >
            Bathroom &amp; Kitchen Specialists · Est. 2022 · Warsash
          </span>
          <h1
            data-testid="hero-title"
            className="mt-6 font-heading text-4xl sm:text-5xl lg:text-[64px] leading-[1.05] text-[#1C2A39] font-medium"
          >
            Spaces crafted with{" "}
            <span className="italic font-light text-[#C9A24A]">care</span>,
            installed with{" "}
            <span className="italic font-light text-[#C9A24A]">precision</span>.
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-7 text-lg text-[#5C6670] leading-relaxed max-w-[520px]"
          >
            From elegant bathrooms to kitchens that become the heart of your
            home — C4 Plumbing &amp; Heating Ltd designs and installs lasting
            spaces for UK homes. View our previous work and request a
            no-obligation quotation.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <Button
              data-testid="hero-quote-cta"
              onClick={() => scrollTo("quote")}
              className="bg-[#C9A24A] hover:bg-[#B0893A] text-white rounded-sm h-12 px-7 font-heading font-semibold tracking-wide"
            >
              Request a Quotation
              <ArrowRight className="ml-2" size={16} strokeWidth={1.75} />
            </Button>
            <Button
              data-testid="hero-portfolio-cta"
              variant="outline"
              onClick={() => scrollTo("portfolio")}
              className="bg-transparent border border-[#1C2A39] text-[#1C2A39] hover:bg-[#1C2A39] hover:text-white rounded-sm h-12 px-7 font-heading font-semibold tracking-wide"
            >
              See Our Work
            </Button>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-[460px]">
            {[
              { icon: ShieldCheck, label: "Gas Safe", sub: "Registered" },
              { icon: Hammer, label: "11+ Years", sub: "On the tools" },
              { icon: Sparkles, label: "Fixed-Price", sub: "Quotations" },
            ].map((b) => (
              <div
                key={b.label}
                data-testid={`hero-trust-${b.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="border-l border-[#E8E5DD] pl-4"
              >
                <b.icon
                  size={20}
                  strokeWidth={1.5}
                  className="text-[#C9A24A]"
                />
                <div className="mt-2 font-heading text-sm text-[#1C2A39] font-semibold">
                  {b.label}
                </div>
                <div className="text-xs text-[#5C6670]">{b.sub}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 relative c4-rise" style={{ animationDelay: "0.2s" }}>
          <div className="relative aspect-[4/5] w-full overflow-hidden">
            <img
              src={HERO_IMAGE}
              alt="Premium modern bathroom installation"
              data-testid="hero-image"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[#E8E5DD]/60" />
          </div>
          <div className="absolute -bottom-8 -left-8 hidden md:block bg-[#1C2A39] text-[#F9F8F6] p-6 max-w-[260px] c4-grain">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E9D28B] font-semibold">
              Bespoke Process
            </div>
            <div className="mt-2 font-heading text-lg leading-snug">
              Design · Source · Install — managed by one trusted team.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
